/** @format */
import { useTranslation } from "react-i18next";
import MaintenanceImage from "../../assets/images/site-maintenance-illustration.svg?react";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

export const PublicPastPapersPage = () => {
	const { t } = useTranslation();
	useDocumentTitle(t("pageTitles.pastPapers"));
	return (
		<div className="flex flex-col md:flex-row items-center justify-center gap-10 md:gap-20 h-full w-full px-4 text-center md:text-left">
			<div>
				<h1 className="font-black font-lato text-[24px] xl:text-[30px] mb-3">{t("examGenerator.comingSoon")}</h1>
				<div className="flex flex-col w-full max-w-180 flex-wrap">
					<p className="font-lato text-[14px] xl:text-[17px]">{t("pastPapers.message")}</p>
					<a
						href="https://www.wjec.co.uk/home/past-papers/"
						target="_blank"
						rel="noopener noreferrer"
						className="text-(--public-color-link) underline"
					>
						https://wjec.co.uk/home/past-papers
					</a>
				</div>
			</div>
			<div>
				<MaintenanceImage className="w-60 h-60 xl:w-100 xl:h-100" />
			</div>
		</div>
	);
};
